import { CardDetails, Cards } from "@/modules/card/components";
import { PageHeader } from "@/shared/components";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setActiveCardId } from "@/shared/state/common";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const CardsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const activeItem = useAppSelector(state => state.common);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeCardDetails = () => {
    setIsOpen(false);
    dispatch(setActiveCardId(null));
  };

  useEffect(() => {
    if (activeItem?.cardId) {
      setIsOpen(true);
    }
  }, [activeItem]);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-32">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("cards.title")}
              </Heading>
            </div>
            <Cards cardId={`${activeItem?.cardId}`}/>
          </div>
        </div>
      </div>
      {isOpen && (
        <CardDetails
          isOpen={isOpen}
          cardId={`${activeItem?.cardId}`}
          onClose={closeCardDetails}
        />
      )}
    </>
  );
};
